module.exports = __webpack_public_path__ + "media/images/phone-conf-7b82ece1899e754a60198bf29047eb72e0f00c2fcb8ae36f466c20bc74fd686f.jpg";